import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=e95ca818"
import script from "./ContentItem.ts?vue&type=script&lang=ts&external"
export * from "./ContentItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports